"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var LinkedinIcon = function LinkedinIcon() {
  return _react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 148.1 128.07"
  }, _react.default.createElement("g", {
    "data-name": "Camada 2"
  }, _react.default.createElement("g", {
    "data-name": "Camada 1"
  }, _react.default.createElement("path", {
    d: "M74.11 23.2h60.44c10.11 0 13.53 3.41 13.53 13.36v18c0 6-2.3 9.27-8.26 10.67q-23.9 5.63-47.9 10.77c-3.07.65-4.12 1.79-4 4.9.5 11.91-1.1 10.16-10.45 10.18-4 0-8-.14-12 0s-5.29-1.68-5.42-5.36C59.77 77 59.69 77 50.69 75l-40.18-9C2.38 64.19 0 61.27 0 52.93V35.45C0 27 3.84 23.24 12.68 23.22c20.48-.05 40.96-.02 61.43-.02zm14 46.23c16.9-3.78 33.05-7.3 49.12-11.16 1.49-.36 3.42-2.79 3.52-4.37.41-6.13.13-12.31.18-18.47 0-3.09-1.19-4.45-4.47-4.44q-62.43.11-124.88 0c-3.24 0-4.53 1.28-4.49 4.41.06 5.66.25 11.34-.06 17-.25 4.31 1.82 5.86 5.61 6.63 7.36 1.45 14.56 3.21 21.82 4.8 8.35 1.83 16.71 3.6 25 5.39 1.7-5.39 1.73-5.48 6.58-5.55 5.33-.07 10.66.11 16-.06 3.71-.12 6.11 1.04 6.11 5.82zm-8.34 14.18v-12.2H68.34v12.2z"
  }), _react.default.createElement("path", {
    d: "M74 128.06H16c-9 0-12.89-3.83-12.92-12.61v-39c0-3 .16-6.26 4-6.16s3.87 3.39 3.87 6.35c0 12.83.14 25.66-.09 38.49-.08 4.22 1.51 5.46 5.5 5.45q57.74-.12 115.47 0c4.05 0 5.48-1.36 5.4-5.53-.24-12.16-.09-24.33-.09-36.49 0-1-.35-2.2.08-3a63.44 63.44 0 013.87-5.45c1.3 1.79 3.63 3.51 3.73 5.37.44 7.47.19 15 .19 22.48v18c-.07 7.88-4.14 12-12 12-19.67.13-39.33.1-59.01.1zM74.46 0c5.33 0 10.66-.06 16 0 8 .1 13.19 7.45 10.41 14.89-.4 1.07-2.58 2.17-3.79 2s-3-2-2.93-2.94c.55-6.31-2.94-7.07-8-6.91-8.65.26-17.31.19-26 0C56 7.05 54 8.37 54 12.84A5.57 5.57 0 0150.67 17c-3.12.75-3.67-1.7-3.67-4.36C46.7 3.89 50.29.05 59 0z"
  }))));
};

var _default = LinkedinIcon;
exports.default = _default;